// DS: C35
import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileSubmissionDetails from './MobileSubmissionDetails';
import DesktopSubmissionDetails from './DesktopSubmissionDetails';
const SubmissionDetails = (props)=>{
    const isMobile = useContext(MobileContext);
    return isMobile ? /*#__PURE__*/ React.createElement(MobileSubmissionDetails, _extends({}, props)) : /*#__PURE__*/ React.createElement(DesktopSubmissionDetails, _extends({}, props));
};
SubmissionDetails.displayName = 'SubmissionDetails';
export default SubmissionDetails;
